<template>
  <div>
    <van-nav-bar title="首页" left-text="返回" left-arrow @click-left="onClickLeft" />
    <div v-if="show6"
         style="position: fixed;;z-index:5999;width: 370px;margin-top: -5.5rem; margin-left: 2.7rem;"
    >
      <div style="background-color: skyblue;position: relative;top:50px;width: 20.1rem;left:0.1rem; white;height: 49px;">
        <span style="font-size:15px;position:relative;left: 1rem;color: white;">春雪人力正在与您对话</span>
        <span style="font-size: 30px;position:relative;left: 9rem; top:0.4rem; color: white; " @click="show6=false">X</span>
      </div>
      <iframe id="ifrPage" src="http://chat.looyuoms.com/chat/chat/p.do?c=20002527&f=10115864&g=10086528" name="ifrPage" style="  height: 33rem;width: 20rem"/>

    </div>
    <!-- <van-button type="primary"
              text="显示遮罩层" @click="show6 = true"
      /> -->
    <van-overlay :show="show6" @click="show6 = false" />·

    <div class="header"><img style="width: 150px; " src="../../../static/logo.png" class="logo" alt="" ></div>
    <div class="cx-box">
      <van-swipe :autoplay="3000" class="my-swipe" indicator-color="white" style="position: relative;top: 0px; margin: 0 auto;  text-align: center; ">
        <van-swipe-item><van-image width="375" height="150" src="../static/public/微信图片1.png" /></van-swipe-item>
        <van-swipe-item><van-image width="375" height="150" src="../static/public/微信图片2.png" /></van-swipe-item>
        <van-swipe-item><van-image width="375" height="150" src="../static/public/微信图片3.jpg" /></van-swipe-item>
      </van-swipe>
    </div>
    <div style="background-color: white;">
      <van-row type="flex" style="position: relative; top: 0px; margin: 0 10px;">
        <van-col span="12">
          <van-collapse v-for="(item, index) in Menux" v-if="index % 2 == 0" :key="item.id" :title="item.name" v-model="activeNames" accordion @change="showPopup(item.id)">
            <van-collapse-item :title="item.name" :name="item.id">
              <template #title>
                <van-row type="flex" justify="space-around">
                  <van-col span="24">
                    <p>
                      <van-image
                        :src="who == 0 ? cli_imgSrc[index] : imgSrc[index]"
                        style="position: relative;top: 5px;right: 0px;"
                        fit="contain"
                        top="20px"
                        width="20"
                        height="20"
                      />
                      {{ item.name }}
                    </p>
                  </van-col>
                </van-row>
              </template>

              <p v-for="(ix, id) in children" :key="id" style="color: #0077AA ; cursor:pointer; font-size: 13px;" @click="childrenx(ix.name, ix.url)">
                <van-image style="position: relative;top: 0.195rem;" width="14" height="14" src="../../../static/icon/三角形.png" />
                {{ ix.name }}
              </p>
            </van-collapse-item>
          </van-collapse>
        </van-col>

        <van-col span="12">
          <van-collapse v-for="(item, index) in Menux" v-if="index % 2 !== 0" :key="item.id" :title="item.name" v-model="activeNames" accordion @change="showPopup(item.id)">
            <van-collapse-item :title="item.name" :name="item.id">
              <template #title>
                <van-row type="flex" justify="space-around">
                  <van-col span="24">
                    <p>
                      <van-image
                        :src="who == 0 ? cli_imgSrc[index] : imgSrc[index]"
                        style="position: relative;top: 5px;right: 0px;"
                        fit="contain"
                        top="20px"
                        width="20"
                        height="20"
                      />
                      {{ item.name }}
                    </p>
                  </van-col>
                </van-row>
              </template>
              <p v-for="(ix, id) in children" :key="id" style="color: #0077AA ; cursor:pointer; font-size: 13px;" @click="childrenx(ix.name, ix.url)">
                <van-image style="position: relative;top: 0.105rem;" width="14" height="14" src="../../../static/icon/三角形.png" />
                {{ ix.name }}
              </p>
            </van-collapse-item>
          </van-collapse>
        </van-col>
      </van-row>
    </div>
    <van-row style=" height: 40px; display: block;overflow: hidden; margin-top: 5px;">
      <van-col span="15">
        <van-image width="30" height="25" style="padding-top: 4px;padding-left: 15px;" src="../../../static/icon/热销-2.png" alt="" />
        <p style="position: relative;left: 45px;top: -42px; font-weight: bold;">热销活动</p>
      </van-col>

      <van-col span="8" />
    </van-row>
    <van-row justify="space-around" style="text-align: center; border: 1px solid floralwhite;font-size: 13px;">
      <van-col span="8">
        <van-image width="40" height="40" src="../../../static/icon/HR共享.png" alt="" />
        <br >
        HR共享
      </van-col>
      <van-col span="8">
        <van-image width="40" height="40" src="../../../static/icon/成长课堂.png" alt="" />
        <br >
        成长课堂
      </van-col>
      <van-col span="8">
        <van-image width="40" height="40" src="../../../static/icon/员工福利.png" alt="" />
        <br >
        员工福利
      </van-col>
    </van-row>

    <van-popup v-model="canbao_show" :style="{ height: '50%' }" position="bottom" close-icon="close">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        type="date"
        title="选择年月日"
        @cancel="canbao_show = false"
        @confirm="canbao_date(currentDate)"
      />
    </van-popup>
    <van-popup v-model="show2" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker v-model="currentDate" :min-date="minDate" :max-date="maxDate" type="date" title="选择年月日" @cancel="show2 = false" @confirm="date(currentDate)" />
    </van-popup>

    <van-popup v-model="show3" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        type="date"
        title="选择年月日"
        @cancel="show3 = false"
        @confirm="birthdaychange(currentDate)"
      />
    </van-popup>
    <!--  <van-list
      v-show="vanlist"
      v-model="loading"
      :finished="finished"
      style="position: absolute;top: 10%;left:30%; z-index:3005;  background-color: white;"
      finished-text="没有更多了"
    > -->
    <!--    <van-cell v-for="item in list1" :key="item.id" :title="item.name" style="cursor: pointer;" @click="onthis(item.id, item.name)" />
    </van-list> -->
    <van-popup v-model="show" style=" height: 800px; width: 90%">
      <van-form @submit="xccc">
        <!--  <van-form v-if="!insert" @submit="onSubmit"> -->
        <!-- <van-field v-model="timeValue" :rules="[{ required: true, message: '请选择入职时间！' }]" label="入职时间" readonly @focus="(show2 = true), noBomBox" />-->
        <van-field v-model="clientName" :rules="[{ required: true, message: '请填写企业名称！' }]"
                   label="所属企业" style="position:relative;"
        >
          <template #button>
            <a class="a-style" @click="client1(clientName, null)">搜索</a>
          </template>
        </van-field>

        <van-field
          v-model="tel"
          :rules="[{ required: true, message: '请填写您的手机号码！' }, { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！' }]"
          type="tel"
          label="手机号"
        />
        <van-field v-model="idCard" :disabled="readonly" :rules="[{ validator, message: '请输入正确的身份证号' }]" type="text" label="身份证号" />
        <base-input v-model="Iname" :rules="rules.name" :disabled="readonly" placeholder="请输入员工姓名" label="员工姓名" @focus="xa" />
        <van-field v-model="birthday" :rules="[{ required: true, message: '请选择出生日期' }]" label="出生日期" @focus="show3 = true" />
        <van-radio-group v-model="radio" direction="horizontal" style="padding:0 4px;">
          <p style="padding:0 14px;color: #646566;font-size: 14px;line-height: 24px;">性别</p>
          <van-radio name="1">男</van-radio>
          <van-radio name="2">女</van-radio>
        </van-radio-group>
        <van-field v-model="nation" :rules="[{ required: true, message: '请输入民族名称' }]" type="text" label="民族" />
        <!-- <van-field v-model="education" type="text" label="最高学历" /> -->
        <van-collapse v-model="education" :rules="[{ required: true, message: '请选择学历' }]" accordion>
          <van-collapse-item :title="'学历:       ' + xueli" style="color:green;" name="1">
            <span v-for="(item, i) in xl" :key="i" style="cursor: pointer;padding-right: 20px; " @click="educationx(item.name, item.id)">{{ item.name }}</span>
          </van-collapse-item>
        </van-collapse>
        <van-radio-group v-model="political" direction="horizontal" style="padding:0 4px;">
          <p style="padding:0 14px;color: #646566;font-size: 14px;line-height: 24px;">政治面貌</p>
          <van-radio name="1">群众</van-radio>
          <van-radio name="2">党员</van-radio>
        </van-radio-group>
        <van-radio-group v-model="activeName" direction="horizontal" style="padding:0 4px;">
          <p style="padding:0 14px;color: #646566;font-size: 14px;line-height: 24px;">职工身份</p>
          <van-radio name="1">工人</van-radio>
          <van-radio name="2">干部</van-radio>
        </van-radio-group>

        <!-- <van-field v-model="qc.number" :rules="[{ required: true, message: '请输入银行卡号！' }]" center clearable label="借记卡号" /> -->
        <van-field v-if="!insert" v-model="number" :rules="[{ message: '请输入银行卡号！' }]" center clearable label="借记卡号" />

        <van-field v-if="!insert" v-model="qc.bank_name" :rules="[{ message: '请选择银行名称！' }]" is-link center clearable label="银行名称" @focus="bank" />
        <van-collapse v-model="hold_nature" accordion>
          <van-collapse-item :title="'户口性质 :       ' + sf2" style="color:green;" name="1">
            <span v-for="(item, i) in sf" :key="i" style="cursor: pointer;padding-right: 20px; " @click="sfyz(item, i)">{{ item }}</span>
          </van-collapse-item>
        </van-collapse>

        <van-field v-model="addr" :rules="[{ required: true, message: '请输入户籍地址' }]" type="text" label="户籍地址" />
        <van-field v-model="live_addr" :rules="[{ required: true, message: '请输入现住址' }]" type="text" label="现住址" />
        <van-field v-model="mail" type="text" label="邮箱" />
        <van-row type="flex" justify="space-between" style="text-align: center; padding-bottom: 10px;padding-top: 20px;">
          <van-col span="12">
            <div style="margin: 16px;"><van-button round block type="warning" @click="can">取消</van-button></div>
          </van-col>
          <van-col span="12">
            <div style="margin: 16px;"><van-button v-if="!insert" round block type="primary" native-type="submit">修改</van-button></div>
            <div style="margin: 16px;"><van-button v-if="insert" round block type="primary" native-type="submit" @click="AddEmp = true">提交</van-button></div>
          </van-col>
        </van-row>
      </van-form>
    </van-popup>
    <div>
      <van-popup v-model="showA" round position="bottom">
        <van-search v-model="emp.value" show-action label="姓名" placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-picker :columns="emp_name" show-toolbar @cancel="showA = false" @confirm="SonConfirm" />
      </van-popup>
    </div>
    <van-form @submit="submit">
      <van-popup v-model="canbao" style="border: 1px saddlebrown solid; height: 660px; width: 90%;" closeable>
        <van-tabs v-model="active" sticky @click="onClick">
          <van-tab>
            <template #title>
              <van-icon style="top: 2px;" name="orders-o" />
              新参保信息
            </template>
            <van-field v-model="idCardx" :rules="[{ validator, message: '请输入正确的身份证号！' }]" center clearable label="身份证号" placeholder="请输入身份证号" @blur="wxId" />
            <van-field v-model="namex" :rules="[{ required: true, message: '请输入姓名！' }]" center clearable label="姓名" />
            <van-field v-model="number2" :rules="[{ required: true, message: '请输入银行卡号！' }]" center clearable label="借记卡号" />
            <van-field v-model="bank_namex" :rules="[{ required: true, message: '请输入银行名称！' }]" is-link center clearable label="银行名称" @focus="bank" />
            <van-field v-model="yy1" :rules="[{ required: true, message: '请填写定点医院名称1！' }]" center clearable label="定点医院1">
              <template #button>
                <van-button size="small" type="primary" @click="dy2(yy1, 1)">搜索</van-button>
              </template>
            </van-field>
            <van-field v-model="sms" :rules="[{ required: true, message: '请填写定点医院名称2！' }]" center clearable label="定点医院2">
              <template #button>
                <van-button size="small" type="primary" @click="dy2(sms, 2)">搜索</van-button>
              </template>
            </van-field>
            <van-field v-model="yy2" center clearable label="定点医院3" placeholder="请输入定点医院名称">
              <template #button>
                <van-button size="small" type="primary" @click="dy2(yy2, 3)">搜索</van-button>
              </template>
            </van-field>
            <van-field v-model="yy3" center clearable label="定点医院4" placeholder="请输入定点医院名称">
              <template #button>
                <van-button size="small" type="primary" @click="dy2(yy3, 4)">搜索</van-button>
              </template>
            </van-field>
            <van-field v-model="yy4" center clearable label="社区医院" placeholder="请输入社区医院名称">
              <template #button>
                <van-button size="small" type="primary" @click="dy2(yy4, 5)">搜索</van-button>
              </template>
            </van-field>
            <van-radio-group v-model="pact_type" direction="horizontal" style="">
              <p style="padding:0 14px; color: black;font-size: 14px;line-height:44px; height: 44px; ">劳动合同类型</p>
              <van-radio name="1" style="font-size: 13px;">固定期限</van-radio>
              <van-radio name="2" style="font-size: 13px;">无固定期限</van-radio>
            </van-radio-group>
            <van-row style="color: #646566;font-size: 14px;line-height: 44px;">
              <van-col span="8" style="padding:0 14px; ">合同起始时间</van-col>
              <van-col span="7">
                <van-field
                  v-model="qc.pact_begin_date"
                  :rules="[{ required: true, message: '起始时间！' }]"
                  readonly
                  style="font-size: 12px; width:100px;padding-left: 2px; height:44px;border: 1px solid #F2F2F2;"
                  @focus="(canbao_show = true), (ifx = 1)"
                />
              </van-col>
              <van-col span="1" style="text-align: center;height:44px;position: relative;left: -3px;">--</van-col>

              <van-col span="7">
                <van-field
                  v-model="qc.pact_end_date"
                  :rules="[{ required: true, message: '结束时间！' }]"
                  readonly
                  style="font-size: 12px;border: 1px solid #F2F2F2;  padding-left: 2px;width:100px; height:44px; "
                  @focus="(canbao_show = true), (ifx = 2)"
                />
              </van-col>
            </van-row>
            <van-row type="flex" justify="center">
              <van-col span="24"><base-date v-model="qc.pact_sign_date" placeholder="请选择劳动合同签署时间" label="合同签署时间" /></van-col>
            </van-row>
            <van-field
              v-if="who == 0 ?true:false"
              v-model="qc.pact_sign_salary"
              :rules="[{ required: true, message: '请输入约定工资！' }]"
              placeholder="请输入劳动合同约定工资"
              label="合同约定工资"
              type="digit"
            />
            <div style="font-size: 10px; margin: 10px; color: #CFCFCF;">
              注：银行账户信息仅用于养老支付、失业金领取、医疗及生育报销等社保操作，请填写正确避免日后相关待遇领取异常。
            </div>
            <van-row type="flex" justify="space-between" style="text-align: center; padding-bottom: 10px;">
              <van-col span="12"><van-button type="info" @click="cancel">取消</van-button></van-col>
              <van-col span="12"><van-button type="info" native-type="submit">提交</van-button></van-col>
            </van-row>
          </van-tab>
          <van-tab>
            <template #title>
              <van-icon name="photo-o" style="top: 2px;" />
              新参保照片
            </template>
            <!-- 居中 -->
            <van-row type="flex" justify="center" style="text-align: center;"><van-col span="24">证件照</van-col></van-row>
            <span style="font-size: 12px; color: #8a8a8a;text-align: center;padding-left: 23%;padding-top: 30px;">(若添加失败，请刷新页面重新提交)</span>

            <van-row type="flex" justify="center">
              <van-col span="24" style=" text-align: center;">
                <van-uploader
                  v-model="fileList"
                  :max-count="99"
                  :disabled="!canUpload"
                  :deletable="canUpload"
                  :after-read="afterRead"
                  accept="*"
                  upload-text="请选择文件"
                  multiple
                />
              </van-col>
            </van-row>
            <span style="font-size: 12px; color: #8a8a8a;text-align: center;padding-left: 10px;padding-top: 20px;">（社保要求一寸白底彩照，尽量穿深色衣服，避免有阴影！）</span>
            <van-row type="flex" justify="center" style="text-align: center;margin-top: 20%"><van-col span="24">身份证照</van-col></van-row>
            <van-row type="flex" justify="center">
              <van-col span="24" style=" text-align: center;">
                <van-uploader
                  v-model="SfileList"
                  :max-count="99"
                  :disabled="!ScanUpload"
                  :deletable="ScanUpload"
                  :after-read="SafterRead"
                  accept="*"
                  upload-text="请选择图片"
                  multiple
                />
              </van-col>
            </van-row>
            <van-row>
              <van-col span="6"/>
              <van-col span="12"><van-button style="margin-top: 1.25rem; " size="large" color="linear-gradient(to right, #8ed0c9, #8ed0c9)" @click="active=0">
                去提交
              </van-button></van-col>
              <van-col span="6"/>
            </van-row>

          </van-tab>
        </van-tabs>
      </van-popup>
    </van-form>

    <van-popup v-model="swcli" round position="bottom"><van-picker :columns="list1" show-toolbar @cancel="swcli = false" @confirm="onConfirmCli" /></van-popup>

    <van-popup v-model="showPicker" round position="bottom"><van-picker :columns="columns" show-toolbar @cancel="showPicker = false" @confirm="onConfirm" /></van-popup>
    <van-popup v-model="showx" round position="bottom"><van-picker :columns="bank_name" show-toolbar @cancel="showx = false" @confirm="onback" /></van-popup>
    <!-- 社保普通增员 -->
    <van-popup v-model="social_add_show" style="padding:20px 15px;height:460px;width:90%"><social-common-add :qc="qcSocialAdd" @close="handleCloseSocialAdd" /></van-popup>
    <!-- 社保普通减员 -->
    <van-popup v-model="social_del_show" style="padding:20px 15px;height:400px;width:90%"><social-common-del @close="handleCloseSocialDel" /></van-popup>
    <!-- 社保信息变更 -->
    <van-popup v-model="social_update_show" style="padding:20px 15px;width:90%"><social-common-upd @close="handleCloseSocialupd" /></van-popup>
    <!-- 定点医院变更 -->
    <van-popup v-model="hos_update_show" style="padding:20px 15px;width:90%"><social-hos-update @close="handleCloseHosUpdate" /></van-popup>
    <!-- 公积金增员 -->
    <van-popup v-model="fund_add_show" style="padding:20px 15px;height:400px;width:90%"><fund-employee-add :qc="qcFundAdd" @close="handleCloseFundEmployeeAdd" /></van-popup>
    <!-- 公积金减员 -->
    <van-popup v-model="fund_del_show" style="padding:20px 15px;height:400px;width:90%"><fund-employee-del :qc="qcFundDel" @close="handleCloseFundEmployeeDel" /></van-popup>
  </div>
</div></template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import { Notify } from 'vant';
import fundEmployeeAdd from './fund/employee-add';
import fundEmployeeDel from './fund/employee-del';
import socialCommonAdd from './social/common-add';
import socialCommonUpd from './social/common-update';
import { Wxlist, Wxmodify, WxEmpAdd } from '@/api/Hremployee';
import { ClientList, EmpUpload } from '@/api/Hrclient';
import { billadd } from '@/api/Hrbill';
import { WxSocList, WxSocmodify } from '@/api/Hrfund';
import socialCommonDel from './social/common-del';
import socialHosUpdate from './social/hos-update';
import { dax } from '@/utils/date';

import { Overlay } from 'vant';

import { Dialog } from 'vant';
Vue.use(Overlay);
// 全局注册
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Notify);
export default {
  name: 'Index',
  components: { fundEmployeeAdd, fundEmployeeDel, socialCommonAdd, socialCommonDel, socialHosUpdate, socialCommonUpd },
  props: {
    qc: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      pact_type: '1',
      showA: false,
      swcli: false,
      who: parseInt(sessionStorage.getItem('who')),
      imgSrc: [
        '../static/员工信息.png',
        '../static/社保.png',
        '../static/公积金.png',
        '../static/计算社保公积金.png',
        '../static/业务.png',
        '../static/服务评价-客服.png',
        '../static/指南.png'
      ],
      cli_imgSrc: [
        '../static/员工信息.png',
        '../static/社保.png',
        // '../static/审核.png',
        '../static/公积金.png',
        '../static/计算社保公积金.png',
        '../static/审核.png',
        '../static/服务评价-客服.png',
        '../static/HR报表.png',
        '../static/指南.png'
      ],
      emp: {
        value: '',
        disabled: true
      },
      hos: [],
      empList: [],
      emp_name: [],
      AddEmp: false,
      fileList: [],
      SfileList: [],
      canUpload: false,
      ScanUpload: false,
      qcFundAdd: {
        // 公积金增员
        token: sessionStorage.getItem('token'),
        begin_date: null,
        name: null,
        id_card: null,
        phone: null,
        addr: null
      },
      qcFundDel: {
        // 公积金增员
        token: sessionStorage.getItem('token'),
        end_date: null,
        name: null,
        id_card: null,
        emp_id: null
      },
      qcSocialAdd: {
        // 社保普通增员
        token: sessionStorage.getItem('token'),
        end_date: null,
        name: null,
        id_card: null
      },
      active: '0',
      fund_add_show: false,
      fund_del_show: false,
      social_add_show: false,
      social_del_show: false,
      fund_query_show: false,
      hos_update_show: false,
      social_update_show: false,
      showPicker: false,
      activeNames: ['0'],
      activeName: '0',
      columns: [],
      yy1: '',
      idCardx: sessionStorage.getItem('id_card') === 'undefined' ? '' : sessionStorage.getItem('id_card'),
      yy2: '',
      namex: sessionStorage.getItem('username'),
      yy3: '',
      yy4: '',
      yy1s: false,
      number2: '',
      number: '',
      loading2: false,
      sf: ['外埠城镇', '外埠农村', '本市城镇', '本市农村'],
      sf2: '',
      show: false,
      client: false,
      bank_namex: '',
      Iname: '',
      nation: '',
      education: '',
      political: '0',
      hold_nature: '',
      addr: '',
      live_addr: '',
      mail: '',
      clientName: '',
      clientNameS: '',

      text: '',
      phone: '',
      idCard: sessionStorage.getItem('idcard') == 'undefined' ? '' : sessionStorage.getItem('idcard'),
      tel: '',
      password: '',
      level: '',
      sms: '',
      menu: [],
      Menux: [],
      children: [],
      childrenc: [],
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      timeValue: '请选择时间',
      show2: false,
      show3: false,
      birthday: '请选择出生日期',
      radio: '1',
      list: [],
      list2: [],
      info: false,
      loading: false,
      finished: false,
      list1: [],
      vanlist: false,
      canbao: false,
      value: 0,
      switch1: false,
      activeTabbar: 'upload',
      uploading: false,
      uploadingMsg: '',
      uploadingPercentage: 0,
      picture: {},
      Suploading: false,
      SuploadingMsg: '',
      SuploadingPercentage: 0,
      switch2: false,
      option: [{ text: '全部商品', value: 0 }, { text: '新款商品', value: 1 }, { text: '活动商品', value: 2 }],
      clientx: 0,
      area: {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外'
      },
      show6: false,
      xueli: '',
      educationX: 0,
      xl: [{ id: 791, name: '初中及以下' }, { id: 792, name: '高中' }, { id: 793, name: '专科' }, { id: 794, name: '本科' }, { id: 795, name: '硕士' }, { id: 796, name: '博士' }],
      rules: {
        name: [{ required: true, pattern: this.CONST.REG_EXP.PERSON_NAME, message: '姓名不能少于2个字符' }]
      },
      emp: [
        {
          client_id: 0,
          clientName: ''
        }
      ],
      baseInfo: {},
      status: 0,
      xul: 0,
      id: 0,
      bank_name: [],
      showx: false,
      insert: false,
      canbao_show: false,
      readonly: false
    };
  },
  created() {},

  updated() {
    if (!this.show) {
      this.vanlist = false;
    } else if (!this.canbao) {
      this.yy1s = false;
    }
  },
  mounted() {
    this.canUpload = true;
    this.ScanUpload = true;
    const mn = JSON.parse(sessionStorage.getItem('menu'));

    const len = mn.length;
    this.chek_empId();
    // 弹出工单通知

    if (sessionStorage.getItem('popup_time') === '0') {
      if (this.CONST.WHO === '0') {
        this.axios.post('/wxbill/list', { client_id: parseInt(sessionStorage.getItem('client_id')), token: sessionStorage.getItem('token'), status: 1 }).then(resp => {
          if (resp) {
            if (resp.data.success) {
              if (resp.data.total > 0) {
                Notify({ type: 'warning', duration: 15000, message: '您有' + resp.data.total + '条员工申请待审核！' });
              }
            }
          }
        });
        sessionStorage.removeItem('popup_time');
      } else {
        this.readonly = true;
        this.idCard = sessionStorage.getItem('id_card');
        this.Iname = sessionStorage.getItem('username');
        this.idCardx = sessionStorage.getItem('id_card');
      }
    }
    for (let i = 0; i < len; i++) {
      this.Menux.push({
        id: mn[i].id,
        name: mn[i].name,
        url: mn[i].url
      });
    }
    this.Menux[4].name = sessionStorage.getItem('who') === '0' ? '审核申请' : '业务进度';

    const ch = JSON.parse(sessionStorage.getItem('children'));
    const ln = ch.length;
    if (sessionStorage.getItem('who') === '1') {
      for (let ix = 0; ix < ln; ix++) {
        this.childrenc.push({
          id: ch[ix].id,
          pid: ch[ix].pid,
          name: ch[ix].name,
          url: ch[ix].url
        });
      }

      this.childrenc[0].name = sessionStorage.getItem('who') === '0' ? '员工列表' : '员工信息';
    } else {
      this.idCardx = '';
      this.namex = '';
      for (let ix = 0; ix < ln; ix++) {
        this.childrenc.push({
          id: ch[ix].id,
          pid: ch[ix].pid,
          name: ch[ix].name,
          url: ch[ix].url
        });
      }
    }
    this.go(sessionStorage.getItem('id_card'));
  },
  methods: {
    async validID(rule, value, callback) {
      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (reg.test(value)) {
        await this.go(value.length);
        callback();
      } else {
        callback(new Error('身份证号码不正确'));
      }
    },

    // 实现自动生成生日，性别，年龄
    go(val) {
      const iden = val;
      let sex = null;
      let birth = null;
      const myDate = new Date();
      const month = myDate.getMonth() + 1;
      const day = myDate.getDate();
      let age = 0;
      if (iden.length === 18) {
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        sex = iden.substring(16, 17);
        birth = iden.substring(6, 10) + '-' + iden.substring(10, 12) + '-' + iden.substring(12, 14);
        if (iden.substring(10, 12) < month || (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)) age++;
      }
      if (val.length === 15) {
        age = myDate.getFullYear() - iden.substring(6, 8) - 1901;
        sex = iden.substring(13, 14);
        birth = '19' + iden.substring(6, 8) + '-' + iden.substring(8, 10) + '-' + iden.substring(10, 12);
        if (iden.substring(8, 10) < month || (iden.substring(8, 10) == month && iden.substring(10, 12) <= day)) age++;
      }

      if (sex % 2 === 0) {
        sex = '2';
      } else {
        sex = '1';
      }
      this.baseInfo.sex = sex;
      this.baseInfo.age = age;
      this.baseInfo.birthday = birth;

      this.baseInfo.birthplace = this.area[iden.substring(0, 2)];
    },
    noBomBox(Event) {
      document.activeElement.blur();
    },
    xccc() {
      if (!this.insert) {
        this.onSubmit();
      } else {
        this.empadd();
      }
    },
    wxId() {
      if (this.idCardx.length >= 15) {
        Wxlist({ id_card: this.idCardx }).then(res => {
          sessionStorage.setItem('emp_id', res.rows[0].id);
          this.namex = res.rows[0].name;
        });
      }
      if (this.idCard.length >= 15) {
        Wxlist({ id_card: this.idCard }).then(res => {
          sessionStorage.setItem('emp_id', res.rows[0].id);
        });
      }
    },
    onSearch() {
      this.queryX();
    },
    canbao_date(val) {
      dax(val, this.ifx);
      if (this.ifx === 1) {
        this.qc.pact_begin_date = sessionStorage.getItem('pact_date');
        this.canbao_show = false;
      }
      if (this.ifx === 2) {
        this.qc.pact_end_date = sessionStorage.getItem('end_date');
        this.canbao_show = false;
      }
    },
    SonConfirm(value, index) {
      this.showA = false;
      if (this.empList[index].name !== undefined) {
        this.Iname = this.empList[index].name;
      }

      if (this.empList[index].id !== undefined) {
        this.qc.emp_id = this.empList[index].id;

        this.modify();
      }
    },
    async SafterRead(file) {
      if (sessionStorage.getItem('emp_id') !== 'undefined') {
        this.ScanUpload = false;
        this.Suploading = true;
        this.SuploadingPercentage = 0;
        let files = [];
        if (file instanceof Array) {
          files = file;
        } else {
          files.push(file);
        }
        for (let i = 0; i < files.length; i++) {
          this.SuploadingPercentage = parseFloat(parseFloat(((i + 1) / files.length) * 100).toFixed(2));
          this.SuploadingMsg = ` ${i + 1}/${files.length}`;
          const originFile = files[i];
          const suffixPos = originFile.file.name.lastIndexOf('.');
          const suffixName = originFile.file.name.substring(suffixPos + 1);
          const isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null;
          if (isImg) {
            const rst = await this.lrz(originFile.file);
            rst.formData.append('client_id', parseInt(sessionStorage.getItem('client_id')));
            rst.formData.append('create_id', parseInt(sessionStorage.getItem('create_id')));
            rst.formData.append('token', sessionStorage.getItem('token'));
            rst.formData.append('id', sessionStorage.getItem('emp_id'));
            rst.formData.append('type', 2);
            await this.uploadFile(originFile, rst.formData, this.fileOrd++).catch(() => {
              this.error('文件上传失败');
            });
          } else {
            const formData = new FormData();
            formData.append('file', originFile.file);
            await this.uploadFile(originFile, formData, this.fileOrd++).catch(() => {
              this.error('文件上传失败');
            });
          }
        }
        this.ScanUpload = true;
        this.Suploading = false;
        this.picture.S = true;
        this.SuploadingPercentage = 100;
      } else {
        this.active = '0';
        file.status = 'failed';
        file.message = '上传失败';
        this.toast('请先输入身份证号！');
      }
    },
    async afterRead(file) {
      if (sessionStorage.getItem('emp_id') !== 'undefined') {
        this.canUpload = false;
        this.uploading = true;
        this.uploadingPercentage = 0;
        let files = [];
        if (file instanceof Array) {
          files = file;
        } else {
          files.push(file);
        }
        for (let i = 0; i < files.length; i++) {
          this.uploadingPercentage = parseFloat(parseFloat(((i + 1) / files.length) * 100).toFixed(2));
          this.uploadingMsg = ` ${i + 1}/${files.length}`;
          const originFile = files[i];
          const suffixPos = originFile.file.name.lastIndexOf('.');
          const suffixName = originFile.file.name.substring(suffixPos + 1);
          const isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null;
          if (isImg) {
            const rst = await this.lrz(originFile.file);
            rst.formData.append('client_id', parseInt(sessionStorage.getItem('client_id')));
            rst.formData.append('create_id', parseInt(sessionStorage.getItem('create_id')));
            rst.formData.append('token', sessionStorage.getItem('token'));
            rst.formData.append('id', sessionStorage.getItem('emp_id'));
            rst.formData.append('type', 1);
            await this.uploadFile(originFile, rst.formData, this.fileOrd++).catch(() => {
              this.error('文件上传失败');
            });
          } else {
            const formData = new FormData();
            formData.append('file', originFile.file);
            await this.uploadFile(originFile, formData, this.fileOrd++).catch(() => {
              this.error('文件上传失败');
            });
          }
        }
        this.canUpload = true;
        this.uploading = false;
        this.picture.Z = true;
        this.uploadingPercentage = 100;
      } else {
        this.active = '0';
        file.status = 'failed';
        file.message = '上传失败';
        this.toast('请先输入身份证号！');
      }
    },
    uploadFile(originFile, formData, ord) {
      return new Promise((resolve, reject) => {
        for (const key in this.uploadData) {
          formData.append(key, this.uploadData[key]);
        }

        EmpUpload(formData).then(resp => {
          if (resp.success) {
            this.success(resp.msg);
            resolve();
          } else {
            console.error('文件上传失败 ord: ', ord);
            reject(resp.msg);
          }
        });
      });
    },
    xa() {
      if (!this.insert) {
        this.showA = true;
        this.queryX();
      }
    },
    queryX() {
      this.emp_name = [];
      this.empList = [];
      if (sessionStorage.getItem('who') === '1') {
        this.qc.emp_id = parseInt(sessionStorage.getItem('emp_id'));
      }

      Wxlist({
        client_id: parseInt(sessionStorage.getItem('client_id')),
        name: this.emp.value ? this.emp.value : null,
        id: sessionStorage.getItem('who') === '1' ? this.qc.emp_id : null
      }).then(res => {
        for (let i = 0; i < res.rows.length; i++) {
          // this.emp_name.push({ text: res.rows[i].name, disabled: true });
          if (res.rows[i].function_ids.indexOf('10') !== -1 && res.rows[i].s_base > 0 && res.rows[i].status === 1) {
            this.empList.push({
              id: res.rows[i].id,
              id_card: res.rows[i].id_card,
              name: res.rows[i].name,
              phone: res.rows[i].phone,
              client_id: res.rows[i].client_id
            });

            this.emp_name.push({ text: res.rows[i].name, disabled: false });
            // this.emp_name[i].disabled = false;
          }
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClick(name, title) {
      // this.toast(name);
    },
    bank() {
      if (this.number2.length <= 4 && this.number.length <= 4) {
        Toast.fail('请输入正确的银行卡号');
      } else {
        this.showx = true;
        this.sys();
      }
    },
    onback2() {
      this.showx = true;
    },
    onback(value) {
      this.bank_namex = value;
      this.showx = false;
      this.qc.bank_name = value;
    },
    sys() {
      this.axios
        .post('/sys-dictionaries/list', {
          token: sessionStorage.getItem('token'),
          rows: 2000
        })
        .then(res => {
          const length = res.data.rows.length;
          for (let i = 0; i < length; i++) {
            if (res.data.rows[i].type === 32) {
              this.bank_name.push(res.data.rows[i].name);
            }
          }
        });
    },
    cancel() {
      this.canbao = false;
      this.number2 = '';
      this.bank_namex = '';
      this.idCardx = sessionStorage.getItem('idcard') === 'undefined' ? '' : sessionStorage.getItem('idcard');
      this.namex = parseInt(sessionStorage.getItem('who')) === 0 ? '' : sessionStorage.getItem('username');
      this.yy1 = '';
      this.sms = '';
      this.yy2 = '';
      this.yy3 = '';
      this.yy4 = '';
      this.fileList = [];
      this.SfileList = [];
      this.community_hospital = '';
      this.card_no = '';
    },
    can() {
      this.show = false;
    },
    submit() {
      const qc = this._.cloneDeep(this.qc);
      if (this.picture.Z === undefined) {
        this.active = 1;
        this.toast('请上传证件照！');
      } else if (this.picture.S === undefined) {
        this.active = 1;
        this.toast('请上传身份证照！');
      } else {
        this.axios
          .post('/social/employee-modify', {
            client_id: parseInt(sessionStorage.getItem('client_id')),
            emp_id: parseInt(sessionStorage.getItem('emp_id')),
            type: 1,
            id_card: this.idCardx,
            name: this.namex,
            hospital_1: this.yy1,
            hospital_2: this.sms,
            hospital_3: this.yy2,
            hospital_4: this.yy3,
            community_hospital: this.yy4,
            card_no: this.number2,
            bank_name: this.bank_namex,
            apply_type: 1,
            status: 1,
            pact_type: this.pact_type,
            pact_begin_date: qc.pact_begin_date,
            pact_end_date: qc.pact_end_date,
            pact_sign_date: qc.pact_sign_date,
            pact_sign_salary: qc.pact_sign_salary,
            token: sessionStorage.getItem('token')
          })
          .then(res => {
            if (res.data.success) {
              billadd({
                emp_id: parseInt(sessionStorage.getItem('emp_id')),
                client_id: parseInt(sessionStorage.getItem('client_id')),
                id_card: this.idCardx,
                type: '社保-新参保',
                // card_no: this.number2,
                // bank_name: this.bank_namex,
                status: parseInt(sessionStorage.getItem('who')) === 0 ? 2 : 1,
                create_id: parseInt(sessionStorage.getItem('create_id')),
                check_type: 1
              });
              Toast.success('提交成功');
              this.canbao = false;
              this.cancel();
            } else {
              Toast.fail('提交失败');
            }
          });
      }
    },

    handleCloseFundEmployeeAdd() {
      this.fund_add_show = false;
      this.Utils.resetValue(this.qcFundAdd);
    },
    handleCloseFundEmployeeDel() {
      this.fund_del_show = false;
      this.Utils.resetValue(this.qcFundDel);
    },
    handleCloseSocialAdd() {
      this.social_add_show = false;
      this.Utils.resetValue(this.qcSocialAdd);
    },
    handleCloseSocialDel() {
      this.social_del_show = false;
    },
    handleCloseHosUpdate() {
      this.hos_update_show = false;
    },
    handleCloseSocialupd() {
      this.social_update_show = false;
    },
    dy2(value, value2) {
      if (value.length < 2) {
        this.$toast.fail('请至少输入两个字符');
      } else {
        this.showPicker = true;
      }
      switch (value2) {
        case 1:
          this.query(value, 1);
          break;
        case 2:
          this.query(value, 2);
          break;
        case 3:
          this.query(value, 3);
          break;
        case 4:
          this.query(value, 4);
          break;
        case 5:
          this.query(value, 5);
          break;
      }
    },

    query(name, id) {
      this.columns = [];
      this.hos = [];
      this.axios
        .post('/client-hospital/wx-getList', {
          name: name,
          token: sessionStorage.getItem('token')
        })
        .then(res => {
          const len = res.data.rows.length;
          let i = 0;
          for (i; i < len; i++) {
            this.columns.push(res.data.rows[i].name);
            this.hos.push(res.data.rows[i].level);
          }
          this.id = id;
        });
    },
    onConfirmCli(value, index) {
      this.clientName = value;
      this.id = this.list2[index].id;
      this.swcli = false;
    },
    chek_empId() {
      if (sessionStorage.getItem('who') === '1') {
        if (
          sessionStorage.getItem('emp_id') === '' ||
          sessionStorage.getItem('emp_id') === undefined ||
          sessionStorage.getItem('emp_id') === 'undefined' ||
          sessionStorage.getItem('emp_id') === 'null'
        ) {
          Dialog.confirm({
            title: '提示',
            message: '当前账号暂无个人信息（确认添加信息）'
          })
            .then(() => {
              this.hrdefault();
              this.show = true;
              this.insert = true;
              // on confirm
            })
            .catch(() => {
              this.show = false;
              // on cancel
            });
        }
      }
    },
    hrdefault() {
      if (sessionStorage.getItem('id_card') !== 'undefined') {
        this.go(sessionStorage.getItem('id_card'));
      }
      this.idCard = sessionStorage.getItem('who') === '0' ? '' : sessionStorage.getItem('id_card');
      this.birthday = sessionStorage.getItem('who') === '0' ? '' : this.baseInfo.birthday;
      this.radio = sessionStorage.getItem('who') === '0' ? '1' : this.baseInfo.sex;
      this.Iname = sessionStorage.getItem('who') === '0' ? '' : sessionStorage.getItem('username');
    },
    onConfirm(value, index) {
      switch (this.id) {
        case 1:
          this.yy1 = value;
          this.showPicker = false;
          break;
        case 2:
          this.sms = value;
          this.showPicker = false;
          break;
        case 3:
          this.yy2 = value;
          this.showPicker = false;
          break;
        case 4:
          this.yy3 = value;
          this.showPicker = false;
          break;
        case 5:
          this.yy4 = value;
          this.level = this.hos[index];
          if (this.level === '一级' || this.level === '未评级') {
          } else {
            Toast.fail('该行请选择社区医院');
          }
          this.showPicker = false;
          break;
      }
    },
    educationx(value, value1) {
      this.xueli = value;
      this.education = '0';
      this.xul = value1;
    },
    sfyz(value, value1) {
      this.sf2 = value;
      this.hold_nature = '0';
    },
    onthis(id, name) {
      this.clientName = name;
      this.vanlist = false;
      this.yy1s = false;
      this.clientx = id;
      this.yy1 = name;
    },
    client1(value, value1) {
      if (value && value.trim()) {
        // 清除延迟执行
        // this.list = [];
        // 设置延迟执行
        this.list = [];
        this.list1 = [];
        this.list2 = [];
        this.yy1 = '';
        this.ax();
      } else {
        Toast('请填写企业名称');
      }
    },
    ax() {
      if (this.clientName !== null && this.clientName.length !== 0) {
        setTimeout(() => {
          this.axios
            .post('/client/dict', {
              name: this.clientName,
              rows: 5,
              token: sessionStorage.getItem('token')
            })
            .then(res => {
              const len = res.data.rows.length;
              // if (len > 0) {
              //   this.vanlist = true;
              // }
              if (len) {
                for (let i = 0; i < len; i++) {
                  this.list1.push(res.data.rows[i].name);
                  this.list2.push({ id: res.data.rows[i].id, name: res.data.rows[i].name });
                }
                // this.loading = false;
                // 数据全部加载完成
                if (this.list1.length >= len) {
                  this.finished = true;
                }
                this.swcli = true;
              } else {
                Toast('没有查到相关企业');
              }
              
            });
        }, 500);
      }
    },

    validator(val) {
      const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
      if (!reg.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    date(val) {
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      this.timeValue = `${year}-${month}-${day}`;
      this.show2 = false;
    },
    birthdaychange(val) {
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }

      this.birthday = `${year}-${month}-${day}`;

      this.show3 = false;
    },
    empadd() {
      if (this.AddEmp === true) {
        if (parseInt(this.id) === 0) {
          Toast.fail('请点击搜索企业');
        } else if (this.hold_nature === '') {
          Toast.fail('请选择户口性质');
        } else {
          WxEmpAdd({
            client_id: parseInt(this.id),
            entry_date: this.timeValue || new Date(),
            name: this.Iname,
            sex: parseInt(this.radio),
            id_card: this.idCard,
            hold_nature: this.sf2,
            phone: this.tel,
            birthday: this.birthday,
            nation: this.nation,
            education: this.xul,
            addr: this.addr,
            live_addr: this.live_addr,
            mail: this.mail,
            political: parseInt(this.political),
            emp_quality: parseInt(this.activeName)
          }).then(res => {
            if (res.success) {
              Toast.success(res.msg);
              this.show = false;
              this.AddEmp = false;
              this.wxId();
              // this.chek_empId();
            } else {
              Toast.fail(res.msg);
            }
          });
        }
      }
    },
    childrenx(name, url) {
      switch (name) {
        case '员工录入':
          this.hrdefault();
          this.show = true;
          this.insert = true;
          this.bank_namex = '';
          this.qc.bank_name = '';
          this.number = '';
          this.clientName = '';
          this.timeValue = '';
          this.tel = '';
          this.nation = '';
          this.addr = '';
          this.live_addr = '';
          this.mail = '';
          this.client_id = '';
          this.activeName = '1';
          this.sf2 = '';
          this.political = '1';
          break;
        case '员工列表':
          this.chek_empId();
          this.$router.push('/hr/EmpList');
          break;
        case '员工修改':
          this.chek_empId();
          this.show = true;
          // this.clientList();
          this.modify();
          break;
        case '新参保':
          this.chek_empId();
          this.canbao = true;
          break;
        case '普通增员':
          this.chek_empId();
          this.social_add_show = true;
          this.qcSocialAdd.name = sessionStorage.getItem('username');
          this.qcSocialAdd.id_card = sessionStorage.getItem('id_card');
          break;
        case '社保减员':
          this.chek_empId();
          this.social_del_show = true;
          break;
        case '社保信息变更':
          this.chek_empId();
          this.social_update_show = true;
          break;
        case '变更定点医院':
          this.chek_empId();
          this.hos_update_show = true;
          break;
        case '养老保险转移':
          window.open('https://mp.weixin.qq.com/s/ikvIaBvCJWf1r9TvDtmSvw');
          break;
        case '生育报销':
          window.open('/static/生育报销.html');
          break;
        case '医疗报销':
          window.open('/static/医疗报销.html');
          break;
        case '公积金增员':
          this.chek_empId();
          // this.qcFundAdd.name = sessionStorage.getItem('username');
          // this.qcFundAdd.id_card = sessionStorage.getItem('id_card');
          this.fund_add_show = true;
          break;
        case '公积金减员':
          this.chek_empId();
          this.qcFundDel.name = sessionStorage.getItem('who') === '0' ? '' : sessionStorage.getItem('username');
          this.qcFundDel.id_card = sessionStorage.getItem('id_card');
          this.qcFundDel.emp_id = Number(sessionStorage.getItem('emp_id'));
          this.fund_del_show = true;
          break;
        case '公积金查询':
          window.open('https://grwsyw.gjj.beijing.gov.cn/ish/gjjloginstyle/tysfgrgjj.jsp');
          break;
        case '公积金提取':
          window.open('http://gjj.beijing.gov.cn/web/zwfw5/386727/386730/386732/index.html');
          break;
        case '联名卡需知':
          window.open('http://gjj.beijing.gov.cn/web/zwfw5/1736744/index.html');
          break;
        case '员工信息':
          this.chek_empId();
          this.show = true;

          this.modify();
          break;
      }
    },
    modify() {
      this.show = true;
      this.insert = false;
      WxSocList({ emp_id: parseInt(sessionStorage.getItem('emp_id') === 'undefined' ? this.qc.emp_id : sessionStorage.getItem('emp_id')) }).then(res => {
        this.number = res.rows[0].card_no;
        this.qc.bank_name = res.rows[0].bank_name;
      });
      if (sessionStorage.getItem('emp_id') != null) {
        Wxlist({ id: parseInt(sessionStorage.getItem('emp_id') === 'undefined' ? this.qc.emp_id : sessionStorage.getItem('emp_id')) }).then(res => {
          const resx = res.rows[0];
          this.Iname = resx.name;
          this.timeValue = resx.entry_date;
          this.tel = resx.phone;
          this.idCard = resx.id_card;
          this.birthday = this.baseInfo.birthday;
          this.radio = resx.sex.toString();
          this.nation = resx.nation;
          this.addr = resx.addr;
          this.live_addr = resx.live_addr;
          this.mail = resx.mail;
          this.education = resx.education;
          this.client_id = resx.client_id;
          this.qc.number = resx.card_no;
          this.bank_namex = resx.bank_name;
          this.activeName = resx.emp_quality ? resx.emp_quality.toString() : '0';
          this.sf2 = resx.hold_nature;
          this.political = resx.political ? resx.political.toString() : '0';
          this.qc.emp_id = resx.id;
          this.status = resx.status;
          this.qc.s_base = resx.s_base ? resx.s_base : -1;

          for (let i = 0; i < this.xl.length; i++) {
            if (resx.education === this.xl[i].id) {
              this.xueli = this.xl[i].name;
              this.educationX = this.xl[i].id;
            }
          }
          ClientList({ id: resx.client_id }).then(res => {
            this.clientName = res.rows[0].name;
          });
        });
      }
    },
    onSubmit() {
      if (this.show) {
        Wxmodify({
          client_id: this.clientx ? this.clientx : parseInt(sessionStorage.getItem('client_id')),
          entry_date: this.timeValue || new Date(),
          name: this.Iname,
          sex: parseInt(this.radio),
          id_card: this.idCard,
          hold_nature: this.sf2,
          phone: this.tel,
          birthday: this.birthday,
          nation: this.nation,
          education: this.educationX,
          addr: this.addr,
          emp_id: this.qc.emp_id,
          live_addr: this.live_addr,
          mail: this.mail,
          political: parseInt(this.political),
          emp_quality: parseInt(this.activeName)
        }).then(res => {
          if (res.success) {
            WxSocmodify({
              card_no: this.number,
              bank_name: this.bank_namex,
              emp_id: this.qc.emp_id
            });

            if (this.status === 1 && this.qc.s_base >= 0) {
              billadd({
                emp_id: this.qc.emp_id,
                client_id: this.clientx ? this.clientx : parseInt(sessionStorage.getItem('client_id')),
                id_card: this.idCard,
                type: '社保-员工修改',
                addr: this.addr,
                hold_nature: this.sf2,
                card_no: this.number,
                bank_name: this.bank_namex,
                status: 6,
                create_id: parseInt(sessionStorage.getItem('create_id'))
              });
            }
            Toast.success(res.msg);
            this.show = false;
          } else {
            Toast.fail(res.msg);
          }
        });
      }
    },
    showPopup(value) {
      this.menu = [];
      this.children = [];
      const idxa = parseInt(value);
      const menu = this.Menux;
      const ch = this.childrenc;
      if (idxa === 1088) {
        if (sessionStorage.getItem('who') === '1') {
          this.$router.push('/hr/fund-detail-person');
        } else {
          this.$router.push('/hr/fund-detail');
        }
      }
      if (idxa == 1090) {
        // window.open(
        //   'http://chat.looyuoms.com/chat/chat/p.do?c=20002527&f=10115864&g=10086528',
        //   '_self',
        //   'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=100, height=100'
        // );
        // this.axa = 'http://chat.looyuoms.com/chat/chat/p.do?c=20002527&f=10115864&g=10086528';
        this.show6 = true;
        // window.open('http://chat.looyuoms.com/chat/chat/p.do?c=20002527&f=10115864&g=10086528');
      }
      if (idxa === 1089) {
        if (parseInt(sessionStorage.getItem('who')) === 0) {
          this.$router.push('/hr/WxList');
        } else if (parseInt(sessionStorage.getItem('who')) === 1) {
          this.$router.push('/hr/WxListEmp');
        }
      }
      for (let i = 0; i < menu.length; i++) {
        if (idxa === menu[i].id) {
          for (let a = 0; a < ch.length; a++) {
            if (menu[i].id === ch[a].pid) {
              this.children.push({ name: ch[a].name, url: ch[a].url });
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped="scoped">
.van-popup >>> .van-popup--center {
  height: auto;
  padding: 20px;
}
.van-dialog {
  z-index: 2030;
}
.van-cell >>> .van-field__label {
  width: 75fpx;
  color: #323233;

  /* border: 1px solid green; */
}
.van-cell >>> .van-field__control {
  width: 100%;
}
.cx-box {
  /* padding-top: 1em; */
  /* 		padding-bottom: 5em;
		margin: 0 auto;
		margin-top: 1em;
    margin-left: 20px;
		width: 450px;
		height: 100px;
		border-radius: 0.5em;
		background: #fff; */
  margin: 10 10px;
  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.15);
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;

  text-align: center;
  background-color: #ffffff;
}
.van-cell >>> .van-cell--clickable {
  width: 50%;
}
/* .van-popup>>>.van-popup--bottom {
bottom: -150px;
} */

body {
  margin: 0;
  padding: 0;
  font-family: 'montserrat';
  background-image: linear-gradient(125deg, #e4ffcd, #6dd5fa, #2980b9, #e4ffcd);
  background-size: 400%;
  animation: bganimation 15s infinite;
}
.header {
  margin-bottom: 10px;
  padding-top: 0.22em;
  /* height: 78.5px; */
  background: linear-gradient(91deg, #f1eefc, #9dc6ff 70%, #a5bcff); /* （body背景色） */
  text-align: center;
}
.text {
  background: -moz-linear-gradient(top, #000000 0%, #ffffff 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #000000), color-stop(100%, #ffffff));
  background: -webkit-linear-gradient(top, #000000 0%, #ffffff 100%);
  background: -o-linear-gradient(top, #000000 0%, #ffffff 100%);
  background: -ms-linear-gradient(top, #000000 0%, #ffffff 100%);
  background: linear-gradient(to bottom, #000000 0%, #ffffff 100%);
}
.van-collapse-item >>> .van-cell__right-icon {
  margin-top: 16px;
}
.logo {
  /* padding-bottom: 10px; */
}
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }

  .a-style {
    display: inline-block;
    width: 50px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: white;
    border-radius: 3px;
    background: rgb(40,183,89);
  }
</style>



// WEBPACK FOOTER //
// src/components/hr/index.vue